import { ISpaceSection, ISpaceItemSection } from 'shared/types/SpaceArticleSection';
import { ISpaceItems, IBackground } from 'gift-cards/types';

export const transformSubsections = (items) => {
  if (items?.length > 0) {
    return items
      .map(
        ({
          id: spaceItemID,
          type = 'SpaceItemSection',
          buttonLink = '',
          placement,
          ...spaceItem
        }): ISpaceItemSection => {
          const spaceItemSection: ISpaceItemSection = {
            id: spaceItemID,
            type,
            buttonLink,
            placement: { ...placement, opacity: 1 },
          };

          spaceItemSection.mediaAsset = {
            id: spaceItem.productTemplate?.slug || '',
            type: 'picture',
            // Note: use original image instead of cropped image
            url: spaceItem.productTemplate?.imageUrl.replace(/\/crop\/375\//g, '/') || '',
          };

          if (spaceItem.text) {
            spaceItemSection.text = spaceItem.text.text;
            spaceItemSection.fontSize = spaceItem.text.fontSize;
            spaceItemSection.textColor = spaceItem.text.color;
          }
          return spaceItemSection;
        },
      )
      .sort((a, b) => a?.placement?.z - b?.placement?.z);
  }
  return [
    {
      id: 'blankID',
      type: 'SpaceItemSection',
      buttonLink: '',
      placement: {
        x: 0,
        y: 0,
        scaleHeight: 0.0001,
        rotation: 0,
        opacity: 0,
        z: 0,
      },
      mediaAsset: {
        id: 'blankID',
        type: 'picture',
        // This is needed for safari to process an actual item on the page
        url: 'https://image-preprod.foodsworth.com/375/attachments/product_template_pictures/images/004/665/876/original/batman-sonar-suit_dc-comics_silo.png',
      },
    },
  ];
};

export const transformSpaces = ({
  id: spaceSectionID,
  background,
  items,
  itemsList,
}: {
  id: string;
  background: IBackground;
  items?: ISpaceItems[];
  itemsList?: ISpaceItems[];
}): ISpaceSection => {
  const subsections = transformSubsections(items || itemsList);

  const spaceSection: ISpaceSection = {
    subsections,
    id: spaceSectionID,
    type: 'SpaceSection',
    aspectRatio: 0.66818,
  };

  if (background?.asset?.imageUrl) {
    spaceSection.bgImage = background.asset.imageUrl;
  } else {
    spaceSection.bgColor = '#ffffff';
  }
  return spaceSection;
};

export const isGif = (url: string) => /\.(gif)$/.exec(url) != null;
